import { Injectable, computed, signal } from '@angular/core';
import { MfaSessionState, MFA_RESEND_COOLDOWN_MS } from '../models/auth-user.model';

@Injectable({ providedIn: 'root' })
export class MfaStateService {
  private readonly _state = signal<MfaSessionState | null>(null);

  readonly state = this._state.asReadonly();
  readonly hasState = computed(() => this._state() !== null);

  setState(state: MfaSessionState): void {
    this._state.set(state);
  }

  updateExpiresAt(expiresAt: string): void {
    const current = this._state();
    if (current) {
      this._state.set({
        ...current,
        expiresAt,
        codeSentAt: Date.now(),
        resendCooldownEndsAt: Date.now() + MFA_RESEND_COOLDOWN_MS,
      });
    }
  }

  clear(): void {
    this._state.set(null);
  }
}
